<script>
  import { createEventDispatcher } from "svelte";
  import { Dashboard } from "@uppy/svelte";
  import Uppy from "@uppy/core";
  import Tus from "@uppy/tus";
  import { api } from "#src/api";
  import { SUPABASE_ANON_KEY } from "#src/env.js";

  import "@uppy/core/dist/style.css";
  import "@uppy/dashboard/dist/style.css";

  export let uploadUrl;
  /** @type {string|null} */
  export let folder = null;
  export let bucket;
  /** @type {string|null} */
  export let accept = null;
  /** @type {number|null} */
  export let height = null;

  const dispatch = createEventDispatcher();

  let uppy;

  async function initUppy() {
    const { data } = await api.auth.getSession();
    let authenticated = data.session !== null;
    let headers = {};

    if (authenticated) {
      const { access_token } = data.session;
      headers = {
        authorization: `Bearer ${access_token}`,
      };
    } else {
      headers = {
        authorization: `Bearer ${SUPABASE_ANON_KEY}`,
      };
    }

    uppy = new Uppy({
      restrictions: {
        ...(accept && { allowedFileTypes: accept.split(",") }),
      },
      onBeforeFileAdded: (file, files) => {
        // Don't add .DS_Store files
        if (file.name === ".DS_Store") {
          return false;
        }

        return true;
      },
    }).use(Tus, {
      endpoint: uploadUrl,
      headers,
      chunkSize: 6 * 1024 * 1024,
      removeFingerprintOnSuccess: true,
      storeFingerprintForResuming: false,
      allowedMetaFields: ["uuid", "bucketName", "objectName", "contentType", "cacheControl"],
    });

    uppy.on("file-added", (file) => {
      const uuid = crypto.randomUUID();

      if (folder) {
        file.meta = {
          ...file.meta,
          name: file.name,
          uuid,
          bucketName: bucket,
          objectName: `${folder}/${file.meta.relativePath || file.name}`,
          contentType: file.type,
        };
      } else {
        file.meta = {
          ...file.meta,
          name: file.name,
          uuid,
          bucketName: bucket,
          objectName: `${uuid}/doc.${file.extension.toLowerCase()}`,
          contentType: file.type,
        };
      }

      dispatch("file-added", { file });
    });

    uppy.on("complete", (result) => {
      dispatch("complete", { results: result.successful });
    });
  }
</script>

{#await initUppy() then _}
  <div class="isolate dashboard-container">
    <Dashboard
      {uppy}
      props={{
        proudlyDisplayPoweredByUppy: false,
        height: height || 550,
      }} />
  </div>
{/await}

<style>
  div.dashboard-container :global(.uppy-StatusBar-actionBtn--done) {
    display: none;
  }

  div.dashboard-container :global(.uppy-Dashboard-AddFiles-title) {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    margin: 0;
  }
</style>
